import { DeepMap } from 'react-hook-form';
import { JobsiteUpdateInput } from 'apollo/generated/client-operations';
import { ensureNonUndefinedFields } from 'utils';
import { FormInputTypes, TypedFormInputs } from 'components/form';
import { EditJobsiteConfigurationFormData } from 'containers/jobsiteConfiguration/types';
import { Jobsite } from './types';
import {
  getAvigilonSectionInputs,
  getAvigilonSectionDefaultValues,
  getAvigilonSectionUpdateInput,
} from './avigilonSection';

export type EditJobsiteConfigTabFormData = Pick<
  EditJobsiteConfigurationFormData,
  'avigilon'
>;

export const getFormInputs = (
  hasCompletedCutover = false,
): TypedFormInputs<EditJobsiteConfigTabFormData> => {
  return {
    avigilon: {
      element: FormInputTypes.Section,
      layout: '',
      elementProps: {
        title: 'Avigilon',
      },
      children: getAvigilonSectionInputs(hasCompletedCutover),
    },
  };
};

type GetDefaultValuesArgs = {
  jobsite: Jobsite;
  hasCompletedCutover?: boolean;
};

export const getDefaultValues = (
  args: GetDefaultValuesArgs,
): EditJobsiteConfigTabFormData => {
  const { jobsite, hasCompletedCutover = false } = args;
  return {
    avigilon: getAvigilonSectionDefaultValues(jobsite, hasCompletedCutover),
  };
};

export const getJobsiteUpdateInput = (
  jobsite: Jobsite,
  data: EditJobsiteConfigTabFormData,
  dirtyFields: DeepMap<EditJobsiteConfigTabFormData, true>,
  hasCompletedCutover = false,
): JobsiteUpdateInput => {
  return ensureNonUndefinedFields<JobsiteUpdateInput>({
    jobsiteId: jobsite.jobsiteId,
    ...getAvigilonSectionUpdateInput(
      data.avigilon,
      dirtyFields.avigilon,
      hasCompletedCutover,
    ),
  });
};
